import { renderContentFromMetadata } from '@jutro/uiconfig';
import _ from 'lodash';
import React, {
    useCallback, useState, useMemo, useContext, useEffect
} from 'react';
import { withRouter, Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import { useAuthentication } from 'gw-digital-auth-react';
import { Icon, Loader, DropdownSelectField, ModalNextProvider } from '@jutro/components';
import { useDependencies } from 'gw-portals-dependency-react';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { messages as commonMessages } from 'gw-platform-translations';
import { getFontIcon, getProductName } from '../../customer/utils/lobIconUtil';
import metadata from './GoPaperless.metadata.json5';
import messages from './GoPaperless.messages';
import styles from './GoPaperless.module.scss';
import { Link } from 'gw-components-platform-react';
import htmlParser from 'html-react-parser';

const SAVE_MESSAGES = {
    saveDocPreferenceSuccess: 'saveDocPreferenceSuccess',
    saveDocPreferenceError: 'saveDocPreferenceError'
};

function GoPaperless(props) {
    const [formData, updateFormData] = useState({});
    const [accountPolicyData, updateAccountPolicyData] = useState([]);
    const [policyDocConsentValue, updatePolicyDocConsentValue] = useState(false);
    const [status, updateStatus] = useState(null);
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const [isLoading, setIsLoading] = useState(false);
    const { PolicyService } = useDependencies('PolicyService');
    const viewModelService = useContext(ViewModelServiceContext);
    const location = useLocation();
    const[showPaperlessNotification,setPaperlessNotification]= useState(false);
    const auth = useAuthentication();

    const createPolicySummaryVM = (data) => {
            return viewModelService.create(
                data,
                'pc',
                'edge.capabilities.policy.dto.PolicyDocPreferenceDetailsDTO'
            );
    };

    const writeValue = useCallback(
        (value, path) => {
            const nextFormData = _.cloneDeep(formData);
            _.set(nextFormData, path, value);
            updateFormData(nextFormData);
            updateStatus('');
        },
        [formData]
    );

    const writeDocPreferenceValue = useCallback(
        (value, path, index) => {
            const digitalDeliveryTypes = [
                "DigitalDelivery",
                "DigitalDeliveryBroker",
                "EdocDeliveryToBroker_BrokerBill",
              ];
          
              const isDigital = digitalDeliveryTypes.includes(value);
              const updatedConsent = isDigital ? "I Agree to Electronic Delivery" : "Continue Paper Delivery";
              console.log(updatedConsent);
            accountPolicyData[index].electronicConsent_EY = updatedConsent;
            accountPolicyData[index].policyDocDispatchMode.value = value;
            updateAccountPolicyData(_.clone(accountPolicyData));
        },
        [accountPolicyData]
    );

    // const getDocumentPreferenceAvailableValues=(accountData)=>{
    //         return accountData.dispatchMode_EYValue.map((code, i) => {
    //             return {
    //                 code: `${accountData.dispatchMode_EY[i]}`,
    //                 name: `${accountData.dispatchMode_EYValue[i]}`
    //             };
    //         });
    // }


    const getDocumentPreferenceAvailableValues = (accountData = {}) => {
        const modes = accountData.dispatchMode_EY || [];
        const values = accountData.dispatchMode_EYValue || [];
    
        return values.map((val, i) => ({
            code: modes[i] || '',
            name: val
        }));
    };

    const getDocumentPreference = useCallback((item, index, { path: property }) => {
        return (
            <DropdownSelectField
                id={`property${index}`}
                alwaysShowPlaceholder={false}
                path={accountPolicyData[index].policyDocDispatchMode}
                onValueChange={(value, path) => writeDocPreferenceValue(value, path, index)}
                value={accountPolicyData[index].value.policyDocDispatchMode}
                className={styles.involvmentInjuredDropDown}
                availableValues={getDocumentPreferenceAvailableValues(accountPolicyData[index].value)}
            />
        );
    }, [accountPolicyData]);

    const getDataCell = (item, index, { path: property }) => {
        if (item[property] && item[property].value) {
            return (
                <div>
                    {item[property].value}
                </div>
            );
        } else {
            return (
                <div> </div>
            );
        }
    };

    

    const getProductIcon = useCallback((item) => {
        const icon = getFontIcon(item.productCode.value);
        return <Icon role="img" className={styles.policyTypeIcon} icon={icon} title={getProductName(item.productCode)} key={item.productCode} />;
    }, []);

    useEffect(() => {
        if (!viewModelService) {
            return;
        }
        setIsLoading(true);
        if(location.state){
           setPaperlessNotification(true);
          }else{
            setPaperlessNotification(false);
          }
        PolicyService.getUserPolicySummaries(authHeader)
            .then((responseData) => {
                if (responseData && responseData.length > 0) {
                    const hoAndAutoPolicies = responseData.filter((data) => data.periods && data.periods.length > 0)
                        .map((policySummary) => {
                            return createPolicySummaryVM({
                                policyNumber: policySummary.periods[0].policyId,
                                productCode: policySummary.periods[0].productCode,
                                accountNumber: policySummary.accountNumber,
                                policyDocDispatchMode: policySummary.policyDocDispatchMode ? policySummary.policyDocDispatchMode : "",
                                policyDocDispatchModeValue: policySummary.policyDocDispatchModeValue ? policySummary.policyDocDispatchModeValue:"",
                                dispatchMode_EYValue : policySummary.dispatchMode_EYValue,
                                dispatchMode_EY: policySummary.dispatchMode_EY,
                                electronicConsent_EY: policySummary.electronicConsent_EY ? policySummary.electronicConsent_EY : "",
                                
                            });
                        });
                    updateAccountPolicyData(hoAndAutoPolicies);
                }
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
            setIsLoading(false);
        });
    }, [PolicyService, authHeader,viewModelService]);

    const updatePolicyDocEmailConsentValue = (value) => {
        updatePolicyDocConsentValue(value);
    }

    const isEmailOptionSelected = useMemo(() => {
        return accountPolicyData.filter((data) => data.policyDocDispatchMode.value && (data.policyDocDispatchMode.value.code === 'email')).length > 0;
    }, [accountPolicyData]);

    const applyDocPreferenceChanges = useCallback(() => {
        if (isEmailOptionSelected && !policyDocConsentValue) {
            return ModalNextProvider.showAlert({
                title: commonMessages.errorUploadTitle,
                message: messages.policyConsentSelectWarning,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        }
        setIsLoading(true);
        const policiesValues = accountPolicyData.map((data) => data.value);
        const userName= auth.name;
        const userEmailID = auth.user_name;
        PolicyService.updatePolicyDocumentPreference(policiesValues,userName,userEmailID, authHeader)
            .then((res) => {
                updateStatus(SAVE_MESSAGES.saveDocPreferenceSuccess);
            })
            .catch((error) => {
                updateStatus(SAVE_MESSAGES.saveDocPreferenceError);
            }).finally(() => {
            setIsLoading(false);
        });
    }, [policyDocConsentValue, accountPolicyData, authHeader, PolicyService, isEmailOptionSelected, ModalNextProvider]);

    const readValue = useCallback((id, path) => _.get(formData, path), [formData]);

    const overrideProps = useMemo(
        () => ({
            '@field': {
                onValueChange: writeValue
            },
            policyDocTableContainer: {
                data: accountPolicyData
            },
            policyDocPreferenceTable: {
                data: accountPolicyData
            },
            myDocPreferenceError: {
                visible: status === SAVE_MESSAGES.saveDocPreferenceError
            },
            errorDocPreferenceMsg: {
                message: translator(messages[status])
            },
            myDocPreferenceSuccess: {
                visible: status === SAVE_MESSAGES.saveDocPreferenceSuccess
            },
            docPreferenceSuccessMsg: {
                message: translator(messages[status])
            },
            policyDocEmailConsentField: {
                visible: isEmailOptionSelected,
                value: policyDocConsentValue
            },
            savePolicyDocPreferenceData: {
                visible: accountPolicyData && accountPolicyData.length > 0
            },
            paperlessNotification:{
                visible: showPaperlessNotification
            },
            privacyPolicySection: {
                content: htmlParser(translator(messages.policyDocsHeading3))
            },
        }),
        [writeValue, formData, status, accountPolicyData, policyDocConsentValue]
    );
    const resolvers = useMemo(
        () => ({
            resolveValue: readValue,
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                getDataCell: getDataCell,
                getProductIcon: getProductIcon,
                getDocumentPreference: getDocumentPreference,
                applyDocPreferenceChanges,
                updatePolicyDocEmailConsentValue
            },
        }),
        [readValue, accountPolicyData, policyDocConsentValue]
    );
    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }
    return renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers);
}

export default GoPaperless;
